// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dispute-option-item:last-child .top-section .top-section-body {
  align-items: center;
}
.dispute-option-item .top-section {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  padding: 0.5rem;
}
.dispute-option-item .top-section .top-section-header {
  flex-basis: 15%;
  width: 100%;
  align-items: center;
  text-align: center;
}
.dispute-option-item .top-section .top-section-body {
  display: flex;
  height: 100%;
  min-height: 10rem;
  align-items: center;
  width: 100%;
}
.dispute-option-item .top-section .top-section-body p {
  text-align: center;
  margin-bottom: 0.5rem;
  width: 100%;
}
.dispute-option-item .dispute-option-button-container {
  height: fit-content;
  width: 100%;
}
.dispute-option-item .dispute-option-button-container .button-component {
  width: 100%;
}
.dispute-option-item {
  width: 29rem;
  max-width: 33%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: 19rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/OverclaimView/DisputeOptionSection/DisputeOptionItem/index.scss"],"names":[],"mappings":"AAGM;EACE,mBAAA;AAFR;AAOE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AALJ;AAOI;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AALN;AAQI;EACE,aAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AANN;AAQM;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;AANR;AAWE;EACE,mBAAA;EACA,WAAA;AATJ;AAWI;EACE,WAAA;AATN;AAnCA;EAgDE,YAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AAVF","sourcesContent":[".dispute-option-item {\n  &:last-child {\n    .top-section {\n      .top-section-body {\n        align-items: center;\n      }\n    }\n  }\n\n  .top-section {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    height: fit-content;\n    padding: 0.5rem;\n\n    .top-section-header {\n      flex-basis: 15%;\n      width: 100%;\n      align-items: center;\n      text-align: center;\n    }\n\n    .top-section-body {\n      display: flex;\n      height: 100%;\n      min-height: 10rem;\n      align-items: center;\n      width: 100%;\n\n      p {\n        text-align: center;\n        margin-bottom: 0.5rem;\n        width: 100%;\n      }\n    }\n  }\n\n  .dispute-option-button-container {\n    height: fit-content;\n    width: 100%;\n\n    .button-component {\n      width: 100%;\n    }\n  }\n\n  width: 29rem;\n  max-width: 33%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 19rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
